// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"ab313fcb","427":"840ffba1","462":"cbb7390a","624":"a7794b93","671":"1cb6434e","712":"70521543","791":"15cf8b59","793":"3effec56","831":"452bc75c","958":"d4633e3b"}[chunkId] + ".chunk.js";
};